import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useConfig } from "@/context/ConfigContext";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { Loader2, ShieldCheck } from "lucide-react";

export default function Login() {
  const { user, login } = useAuth();
  const { config } = useConfig();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/espace-courtier/tableau-de-bord" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await login(email, password);
      nav("/espace-courtier/tableau-de-bord");
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen brand-navy flex items-center justify-center p-4">
      <Card className="w-full max-w-md p-8">
        {config.logo_url ? (
          <img src={config.logo_url} alt={config.brand_name} className="h-12 w-auto mb-1" />
        ) : (
          <div className="flex items-center gap-2 font-display font-extrabold text-brand-navy text-lg mb-1">
            <ShieldCheck className="text-blue-700" /> {config.brand_name}
          </div>
        )}
        <h1 className="font-display text-2xl font-bold text-slate-900 mt-4">Espace courtier</h1>
        <p className="text-slate-500 text-sm mt-1">Connectez-vous pour accéder au CRM.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div><Label className="mb-2 block">E-mail</Label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" required /></div>
          <div><Label className="mb-2 block">Mot de passe</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" required /></div>
          {error && <p className="text-sm text-rose-600" data-testid="login-error">{error}</p>}
          <Button type="submit" className="w-full" disabled={loading} data-testid="login-submit">
            {loading ? <Loader2 className="animate-spin mr-2" size={16} /> : null} Se connecter
          </Button>
        </form>
      </Card>
    </div>
  );
}
